import React, { useEffect, useState } from 'react';
import CloseReasonService from '../../services/closeReasonService';

const MessengerIncompleteModal = ({ onConfirm, onBack, submitted }) => {
    const [reasons, setReasons]       = useState([]);
    const [selected, setSelected]     = useState('');
    const [otherText, setOtherText]   = useState('');
    const [remark, setRemark]         = useState('');

    useEffect(() => {
        loadReasons();
    }, []);

    const loadReasons = async () => {
        try {
            const resp = await CloseReasonService.SearchCloseReason({ actor_type: 2, status: 1 });
            if (resp.data.is_success && resp.data.result) {
                setReasons(resp.data.result);
            }
        } catch (err) { console.error(err); }
    };

    const handleConfirm = () => {
        if (!selected) return;
        const isOther    = selected === 'other';
        if (isOther && !otherText.trim()) return;

        const reasonLabel = isOther
            ? otherText.trim()
            : reasons.find(r => r.id === selected)?.name || '';

        const note = remark.trim()
            ? `${reasonLabel} | ${remark.trim()}`
            : reasonLabel;

        onConfirm(note);
    };

    if (submitted) {
        return (
            <div className="mim-done">
                <div className="mim-done-icon">
                    <i className="mdi mdi-message-processing" />
                </div>
                <p className="mim-done-title">ส่งเหตุผลการจบงานแล้ว</p>
                <p className="mim-done-sub">
                    รายงานไปยังแอดมินแล้ว<br />
                    งานนี้จะมีสถานะเป็น 'จบงาน' หรือ อาจได้รับการมอบหมายมาอีกครั้ง
                </p>
                <div className="mim-done-footer">
                    <button className="mim-btn mim-btn--primary" onClick={onBack}>
                        รับทราบ
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="mim-root">
            <div className="mim-header">
                <button className="mim-close" onClick={onBack}>
                    <i className="mdi mdi-close" />
                </button>
                <h2 className="mim-title">เหตุผลผลการจบงาน</h2>
            </div>

            <div className="mim-body">
                <p className="mim-label">เลือกเหตุผล</p>
                <div className="mim-list">
                    {reasons.map((r) => (
                        <label key={r.id} className="mim-option">
                            <input
                                type="radio"
                                name="reason"
                                value={r.id}
                                checked={selected === r.id}
                                onChange={() => setSelected(r.id)}
                            />
                            <span>{r.name}</span>
                        </label>
                    ))}
                    {/* อื่นๆ เพิ่มเองเสมอ */}
                    <label className="mim-option">
                        <input
                            type="radio"
                            name="reason"
                            value="other"
                            checked={selected === 'other'}
                            onChange={() => setSelected('other')}
                        />
                        <span>อื่นๆ</span>
                    </label>
                </div>

                {selected === 'other' && (
                    <div className="mim-other">
                        <label className="mim-label-note">
                            ใส่เหตุผล <span style={{ color: 'red' }}>*</span>
                        </label>
                        <textarea
                            className="mim-textarea"
                            placeholder="เกิดอุบัติเหตุระหว่างขี่รถเครื่อง"
                            value={otherText}
                            onChange={(e) => setOtherText(e.target.value)}
                            rows={4}
                        />
                    </div>
                )}
            </div>

            <div className="mim-note-wrap">
                <label className="mim-label-note">หมายเหตุ</label>
                <textarea
                    className="mim-textarea"
                    placeholder="บอกเพิ่มเติม เช่น วางของแล้วแต่ไม่เจอคนรับ"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    rows={3}
                />
            </div>

            <div className="mim-footer">
                <button
                    className="mim-btn mim-btn--primary"
                    onClick={handleConfirm}
                    disabled={!selected || (selected === 'other' && !otherText.trim())}
                >
                    ยืนยัน
                </button>
                <button className="mim-btn mim-btn--ghost" onClick={onBack}>
                    <i className="mdi mdi-arrow-left" /> กลับไปก่อนหน้า
                </button>
            </div>
        </div>
    );
};

export default MessengerIncompleteModal;